/* Black Friday display only. Shopify remains the authority for discounts and delivery. */
(() => {
  'use strict';
  const configNode = document.getElementById('pkd-bfcm-config');
  if (!configNode || window.PipkindBfcm) return;
  const config = JSON.parse(configNode.textContent);
  const root = config.root || '/';
  const offer = document.querySelector('[data-bfcm-offer]');
  const api = {
    cart: null,
    active() {
      const end = Date.parse(config.endsAt || '');
      return config.active && config.currency === 'USD' && (!Number.isFinite(end) || Date.now() < end);
    },
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: config.currency || 'USD' }).format(cents / 100); },
    discountUrl(redirect) {
      if (!this.active()) return null;
      const safe = new URL(redirect, location.origin);
      if (safe.origin !== location.origin) return null;
      return `${root}discount/${encodeURIComponent(config.code)}?redirect=${encodeURIComponent(safe.pathname + safe.search + safe.hash)}`;
    },
        renderApplyState(cart) {
      const button = offer?.querySelector('[data-bfcm-apply]');
      if (!button) return;

      const code = String(config.code || '').trim().toLowerCase();
      const discount = cart?.discount_codes?.find(entry =>
        String(entry.code).trim().toLowerCase() === code
      );

      const empty = cart?.item_count === 0;
      const applied = cart?.item_count > 0 && discount?.applicable === true;
      const saved = empty && Boolean(discount) && !this.applyError;
      const wardrobe = document.querySelector('.pkd-bfcm-wardrobe');

      button.disabled = Boolean(this.applying || wardrobe?.syncing);
      button.setAttribute('aria-busy', String(Boolean(this.applying)));
      button.dataset.bfcmApplied = String(Boolean(applied));
      button.textContent = this.applying ? 'APPLYING'
        : applied ? 'APPLIED ✓' : saved ? 'SAVED' : 'APPLY';

      const status = offer.querySelector('[data-bfcm-apply-status]');
      if (status) {
        let message = '';

        if (!this.applying) {
          if (this.applyError) {
            message = this.applyError;
          } else if (saved) {
            message = 'Code saved. Add eligible items to apply.';
          } else if (this.applyRequested && !applied) {
            message = empty || !Array.isArray(cart?.discount_codes)
              ? 'Could not confirm this code. Please try again.'
              : 'Code not applied. Check your cart meets the offer conditions.';
          }
        }

        status.textContent = message;
        status.hidden = !message;
      }
    },
    async applyDiscount() {
      if (this.applying || !this.active()) return;
      const wardrobe = document.querySelector('.pkd-bfcm-wardrobe');
      if (wardrobe?.syncing) return;
      this.applying = true;
      this.applyRequested = true;
      this.applyError = '';
      this.renderApplyState(this.cart);
      try {
        const currentResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!currentResponse.ok) throw new Error('Could not read the cart.');
        const current = await currentResponse.json();
        const codes = (current.discount_codes || []).map(entry => String(entry.code).trim()).filter(Boolean);
        const code = String(config.code || '').trim();
        if (!code) throw new Error('No offer code configured.');
        if (!codes.some(existing => existing.toLowerCase() === code.toLowerCase())) codes.push(code);
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') })
        });
        const cart = await response.json();
        if (!response.ok || cart.status >= 400 || !Array.isArray(cart.items)) throw new Error('Could not apply the code.');
        this.cartRevision = (this.cartRevision || 0) + 1;
        this.cart = cart;
        if (wardrobe?.config) {
          wardrobe.bfcmCart = cart;
          this.renderSelection(wardrobe);
          // Reuse the existing cart refresh without changing any selected items.
          try { await wardrobe.updateCartSections(cart, ++wardrobe.sectionsRevision); } catch (_) { /* Checkout still validates the saved code. */ }
        }
      } catch (_) {
        this.applyError = 'Could not apply the code. Please try again.';
      } finally {
        this.applying = false;
        this.renderApplyState(this.cart);
      }
    },
    async refreshCart() {
      if (!offer) return;
      const revision = this.cartRevision = (this.cartRevision || 0) + 1;
      try {
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (revision !== this.cartRevision) return;
        this.cart = cart;
        this.renderApplyState(cart);
        const wardrobe = document.querySelector('.pkd-bfcm-wardrobe');
        if (wardrobe?.config) { wardrobe.bfcmCart = cart; this.renderSelection(wardrobe); }
      } catch (_) { /* An individual qualifying selection can still be displayed. */ }
    },
    renderSelection(wardrobe) {
      if (!offer || !wardrobe?.config) return;
      const active = this.active();
      offer.hidden = !active;
      if (!active) return;
      const total = Number(wardrobe.estimatedTotal ?? offer.dataset.basePrice);
      if (!Number.isFinite(total)) return;
      const cart = wardrobe.bfcmCart || this.cart;
      const others = (cart?.items || []).filter(item => item.properties?._pipkind_wardrobe !== wardrobe.group && !item.gift_card);
      const otherTotal = others.reduce((sum, item) => sum + Number(item.original_line_price ?? item.line_price ?? 0), 0);
      const gap = Math.max(0, config.minimum - total - otherTotal);
      const qualifies = gap === 0;
      offer.dataset.qualified = String(qualifies);
      const saving = Math.round(total * config.percent / 100);
      const extras = wardrobe.selectedCount();
      const qty = wardrobe.dollQuantity();
      const shipping = config.shippingConfirmed && config.country === 'US';
      offer.querySelector('[data-bfcm-price-label]').textContent = qty === 1 && !extras ? '' : `${qty === 1 ? 'Selected doll' : `${qty} selected dolls`}${extras ? ` + ${extras} ${extras === 1 ? 'accessory' : 'accessories'}` : ''}`;
      offer.querySelector('[data-bfcm-price]').textContent = this.money(qualifies ? total - saving : total);
      const savingNode = offer.querySelector('[data-bfcm-saving]');
      savingNode.textContent = `SAVE ${this.money(saving)}`;
      savingNode.hidden = !qualifies;
      offer.querySelector('[data-bfcm-price-note]').textContent = qualifies
  ? (shipping ? 'Free standard U.S. shipping' : '')
  : `Spend ${this.money(gap)} more to unlock ${config.percent}% off`;
      offer.querySelector('[data-bfcm-code-prefix]').textContent = qualifies ? 'with code' : 'code';
      offer.querySelector('[data-bfcm-gap]').textContent = !wardrobe.baseAvailable() ? 'This option is currently sold out.' : qualifies ? (otherTotal > 0 ? 'Qualifies with the other items in your cart. Final savings are calculated at checkout.' : '') : `Add ${this.money(gap)} in eligible items to unlock the offer${otherTotal > 0 ? ' with your cart' : ''}.`;
      const includes = document.querySelector('[data-bfcm-includes]');
      if (includes) includes.textContent = wardrobe.mode === 'custom' ? 'Doll only: clothing is not included. Add any selected outfits and accessories below.' : 'Dressed as pictured: one doll with the pictured outfit for this option. Extra outfits and accessories sold separately.';
      this.initAttention(wardrobe);
    },
    initAttention(wardrobe) {
      const button = wardrobe.extrasToggle;
      if (!button || button.dataset.bfcmAttentionReady) return;
      button.dataset.bfcmAttentionReady = 'true';
      const stop = () => button.classList.remove('pkd-bfcm-attention');
      button.addEventListener('click', stop);
      button.addEventListener('animationend', stop);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            if (!wardrobe.extraOpen) button.classList.add('pkd-bfcm-attention');
            observer.disconnect();
          }
        }, { threshold: 0.5 });
        observer.observe(button);
      }
    },
    saveSelection(wardrobe) {
      if (!wardrobe?.config) return;
      try {
        sessionStorage.setItem(`pkd-bfcm-selection:${wardrobe.dataset.productId}`, JSON.stringify({ at: Date.now(), mode: wardrobe.mode, quantity: wardrobe.dollQuantity(), items: wardrobe.selectedItems() }));
      } catch (_) { /* The native discount link still works when storage is disabled. */ }
    },
    restoreSelection(wardrobe) {
      const key = `pkd-bfcm-selection:${wardrobe.dataset.productId}`;
      try {
        const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
        sessionStorage.removeItem(key);
        if (!saved || Date.now() - saved.at > 600000 || !Array.isArray(saved.items)) return;
        if (['dressed', 'custom'].includes(saved.mode) && wardrobe.dataset[saved.mode === 'dressed' ? 'dressedAvailable' : 'undressedAvailable'] === 'true') wardrobe.mode = saved.mode;
        if (wardrobe.quantityInput) wardrobe.quantityInput.value = String(Math.max(1, Math.floor(Number(saved.quantity)) || 1));
        wardrobe.products.forEach(row => {
          const field = row.querySelector('[data-wardrobe-variant]');
          const match = saved.items.find(item => field.tagName === 'SELECT' ? [...field.options].some(option => !option.disabled && option.value === String(item.id)) : field.value === String(item.id));
          row.querySelector('[data-wardrobe-check]').checked = Boolean(match) && !row.querySelector('[data-wardrobe-check]').disabled;
          if (match && field.tagName === 'SELECT') field.value = String(match.id);
          row.quantityInput.value = String(Math.max(1, Math.floor(Number(match?.quantity)) || 1));
        });
        wardrobe.extraOpen = wardrobe.mode === 'custom' || wardrobe.selectedCount() > 0;
        wardrobe.changed();
        wardrobe.switchMedia(wardrobe.mode);
      } catch (_) { /* Invalid or expired local selections are ignored. */ }
    }
  };
  window.PipkindBfcm = api;
  document.addEventListener('click', async event => {
    const apply = event.target.closest('[data-bfcm-apply]');
    if (apply) {
      event.preventDefault();
      await api.applyDiscount();
      return;
    }
    const copy = event.target.closest('[data-bfcm-copy]');
    if (copy) {
      try { await navigator.clipboard.writeText(config.code); copy.textContent = `${config.code} ✓`; copy.setAttribute('aria-label', `Copied discount code ${config.code}`); const status = offer?.querySelector('[data-bfcm-copy-status]'); if (status) status.textContent = 'Discount code copied.'; }
      catch (_) { copy.textContent = config.code; }
    }
  });
  window.addEventListener('resident-wardrobe:selection', () => {
    const wardrobe = document.querySelector('.pkd-bfcm-wardrobe');
    if (wardrobe?.estimatedTotal != null) api.renderSelection(wardrobe);
  });
  window.addEventListener('resident-wardrobe:sync', event => {
    if (event.detail?.cart) api.cart = event.detail.cart;
    api.renderApplyState(api.cart);
    if (!event.detail?.pending) api.refreshCart();
  });
  window.addEventListener('pageshow', () => api.refreshCart());
  document.addEventListener('visibilitychange', () => { if (!document.hidden) api.refreshCart(); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => api.refreshCart());
  const reviews = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-widget.jdgm-review-widget');
  const rating = document.querySelector('.pkd-bfcm-product .product-rating');
  if (rating && reviews && !rating.closest('a')) {
    if (!reviews.id) reviews.id = 'pkd-bfcm-reviews';
    const link = document.createElement('a'); link.className = 'pkd-bfcm-review-link'; link.href = `#${reviews.id}`; link.setAttribute('aria-label', 'Read customer reviews');
    rating.replaceWith(link); link.append(rating);
  }
  const end = Date.parse(config.endsAt || '');
  const timer = document.querySelector('[data-bfcm-timer]');
  const countdown = document.querySelector('[data-bfcm-countdown]');
  let interval;
  const tick = () => {
    const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
    if (timer) timer.hidden = !(config.showCountdown && api.active() && Number.isFinite(end) && remaining > 0);
    if (countdown && timer && !timer.hidden) {
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor(remaining % 86400 / 3600);
      const minutes = Math.floor(remaining % 3600 / 60);
      const seconds = remaining % 60;
      const pad = value => String(value).padStart(2, '0');
      countdown.textContent = `${days ? `${days}d ` : ''}${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
      timer.title = `Offer ends ${new Date(end).toLocaleString()} (your local time)`;
    }
    if (Number.isFinite(end) && Date.now() >= end) {
      if (offer) offer.hidden = true;
      document.querySelectorAll('.pkd-bfcm-banner,.pkd-bfcm-card-badge,.pkd-bfcm-card-terms,.pkd-bfcm-card-note').forEach(node => node.remove());
      const wardrobe = document.querySelector('.pkd-bfcm-wardrobe');
      if (wardrobe) api.renderSelection(wardrobe);
      clearInterval(interval);
    }
  };
  tick();
  if (Number.isFinite(end) && end > Date.now()) {
    interval = setInterval(tick, config.showCountdown && timer ? 1000 : 15000);
    window.addEventListener('pageshow', tick);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
  }
  api.refreshCart();
})();
